import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import NuDate from "../../../../../Components/Utils/NuDate";

const Fahas = () => {
  const { data, loading } = UseGetDashBoardData(`/new-dashboard/fahas-details`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-amber-50 flex items-center justify-center text-amber-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Fahas Inspection Renewal</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-amber-50 text-amber-700 border border-amber-200/50">
          MVPI Inspection
        </span>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Vehicle</th>
                <th className="py-2 px-2 text-left">Assignee</th>
                <th className="py-2 px-1 text-center">Expiry Date</th>
                <th className="py-2 px-2 text-right">Days Left</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => {
                  const daysLeft = parseInt(item?.days || 0);
                  const isUrgent = daysLeft <= 15;
                  const isWarning = daysLeft > 15 && daysLeft <= 30;

                  return (
                    <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                      <td className="py-2.5 px-2 font-semibold text-gray-900 truncate max-w-[110px]">
                        {item?.name || "N/A"}
                      </td>
                      <td className="py-2.5 px-2 text-gray-600 truncate max-w-[110px]">
                        {item?.assignedTo || "Unassigned"}
                      </td>
                      <td className="py-2.5 px-1 text-center text-gray-600">
                        {item?.fahasExpDate ? <NuDate value={item?.fahasExpDate} format="DD-MMM-YYYY" /> : "N/A"}
                      </td>
                      <td className="py-2.5 px-2 text-right">
                        <span
                          className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full border ${
                            isUrgent
                              ? "bg-rose-50 text-rose-700 border-rose-200/50"
                              : isWarning
                              ? "bg-amber-50 text-amber-700 border-amber-200/50"
                              : "bg-emerald-50 text-emerald-700 border-emerald-200/50"
                          }`}
                        >
                          {item?.days || 0} days
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-400">
                    No Fahas records available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Fahas;